export default function ProgressBar({ currentStep, totalSteps, isVisibleLabel = false }) {

  // Calcola la percentuale in base al passo corrente
  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full">
      {/* Testo opzionale sopra la barra, utile per indicare i passi */}
      {isVisibleLabel ?

        <div className="mb-2 text-sm font-medium text-gray-700">
          Passo {currentStep} di {totalSteps}
        </div>
        : null
      }

      {/* Contenitore della barra di avanzamento */}
      <div className="w-full bg-gray-200 h-2 rounded-full">
        {/* Barra di riempimento */}
        <div
          className="bg-yellow-400 h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
}

